import {IAlertData, GenericFormContainer, setAlert, apiClient, Breadcrumbs, MuiIcons} from "@leap4/frontend";
import {CreateTaskStore} from "./createTaskStore";
import {ITask} from "../../../../interfaces/ITask";
import {initialTaskObj} from "../base/Task";
import {Link, useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {DetailsForm} from "../base/DetailsForm";
import {connect} from "react-redux";
import {urlsService} from "../../../Routing/urlsService";
import {getTaskTypes} from "../base/utils/functions";

const {AddCircle, HomeOutlined, AddTask: AddTaskIcon} = MuiIcons;

// Style objects for breadcrumbs
const linkStyle = { display: "flex", alignItems: "center", color: "inherit", textDecoration: "none" };
const iconStyle = { marginRight: 4, width: 20, height: 20 };

// Mode enum - was previously imported from internal path
enum Mode {
    Create = "create",
    Edit = "edit"
}

export interface IAddTaskProps {
    setAlert: (data: IAlertData) => void;
}

let store: CreateTaskStore

const _addTask = (props: IAddTaskProps) => {
    const history = useHistory();
    const [task, updateTask] = useState<ITask>(initialTaskObj);

    useEffect(() => {
        store = new CreateTaskStore({
            axiosClient: apiClient,
            alertFunc: props.setAlert,
            baseUrl: `${process.env.REACT_APP_BACKEND_BASE_URL}/api/task`
        })
    }, [])

    const onSubmit = async () => {
        await store.create(task)
        history.goBack();
    };

    return (
        <>
            <Breadcrumbs>
                <Link to={urlsService.tasks()} style={linkStyle}>
                    <HomeOutlined style={iconStyle}/>
                    Tasks Dashboard
                </Link>
                <Link to={urlsService.createTask()} style={linkStyle}>
                    <AddCircle style={{...iconStyle, marginRight: 10}}/>
                    Create Task
                </Link>
                <Link to={urlsService.createTask()} style={linkStyle}>
                    <AddTaskIcon style={{...iconStyle, marginRight: 10}}/>
                    {task.name || ""}
                </Link>
            </Breadcrumbs>
            <GenericFormContainer mode={Mode.Create} onCreateOrEditFunc={onSubmit}
                                  buttonsProps={{goBack: {color: "info"}, editCreate: {color: 'success'}}}>
                <DetailsForm task={task} updateTask={updateTask} mode={"create"} getTaskTypes={getTaskTypes}/>
            </GenericFormContainer>
        </>
    )
}


export const AddTask = connect(null, {
    setAlert: setAlert
})(_addTask);
